import script from "./priceplanView.vue?vue&type=script&setup=true&lang=js"
export * from "./priceplanView.vue?vue&type=script&setup=true&lang=js"

import "./priceplanView.vue?vue&type=style&index=0&id=729d3f8d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-729d3f8d"]])

export default __exports__